var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-240f08fb\",\"hasScoped\":false,\"preserveWhitespace\":false}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./boldPlus.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/uikit/components/AppSvgIcon/iconsTemplate/contents/boldPlus.vue
// module id = 3b6e0a7c5846954e3937
// module chunks = 89